import { render, staticRenderFns } from "./slotLayout.vue?vue&type=template&id=4e93e3a2&"
import script from "./slotLayout.vue?vue&type=script&lang=js&"
export * from "./slotLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports